<div class="container b-h">
  <div class="inscription-role">
    <app-role-card
      roleType="particulier"
      [isSelected]="selectedRole === 'particulier'"
      title="REGISTER_PAGE.PARTICULIER"
      imageSrc="../../../../assets/img/avatar_client.png"
      [isGrey]="selectedRole != 'particulier'"
      (roleClicked)="handleRoleSelection($event)">
    </app-role-card>

    <app-role-card
      roleType="prestataire"
      [isSelected]="selectedRole === 'prestataire'"
      title="REGISTER_PAGE.PRESTATAIRE"
      imageSrc="../../../../assets/img/avatar_provider.png"
      [isGrey]="selectedRole != 'prestataire'"
      (roleClicked)="handleRoleSelection($event)">
    </app-role-card>
  </div>
</div> 